export const ActionTypes = {
  LOADING: "GENERATE_AREA_LOADING",
  ERROR: "GENERATE_AREA_ERROR",
  SUCCESS: "GENERATE_AREA_SUCCESS",
};
